import { useState } from 'react';
import { getCurrentSchoolYear, getPeriodLabel, getPeriods } from '../utils/reportingPeriod';

// Filter state behind the Reporting Period bar. Defaults to the current month of the current school year.
export function useReportingPeriod() {
  const [month, setMonth] = useState(new Date().getMonth());
  const [schoolYear, setSchoolYear] = useState(getCurrentSchoolYear());
  const [rangeMode, setRangeMode] = useState('period');

  return {
    month,
    setMonth,
    schoolYear,
    setSchoolYear,
    rangeMode,
    setRangeMode,
    periods: getPeriods(schoolYear, month, rangeMode),
    label: getPeriodLabel(schoolYear, month, rangeMode),
  };
}
